/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Меню объекта переопределённое в настроках.
 */
export interface ObjectMenuCustomAdd { 
    /**
     * ID объекта (комитета, орг-ция и пр.)
     */
    attachId: string;
    /**
     * 
     */
    codeName: string;
    /**
     * 
     */
    languageCode?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     * @deprecated
     */
    isVisible?: boolean;
    visibilityOption?: string;
}

